/**
 * The build version baked into the bundle at `pnpm build` time.
 *
 * `VITE_BUILD_VERSION` is set in the deploy workflow to the short git SHA of
 * the deployed ref (see `.github/workflows/deploy.yml`). It is NOT part of the
 * web image's content-address hash, so adding it never perturbs the rollout
 * tag. Locally (`make dev`) the var is unset, so we fall back to `dev`.
 */
export function buildVersion(): string {
  const env = import.meta.env as unknown as Record<string, string | undefined>
  const raw = env.VITE_BUILD_VERSION
  return raw != null && raw !== '' ? raw : 'dev'
}
